import BackButton from './ui-components/BackButton'
import MutualFundDetailPageSkeleton from './skeletons/MutualFundDetailPageSkeleton'
import { getTopPadding } from '../utils/sessionStorage'

export const MutualFundDetailLoadingLayout = ({ onBack }: { onBack: (() => void) | null }) => {
  return (
    <div className='flex flex-col gap-3 w-full h-screen animate-fade-150'>
      <div style={{ paddingTop: `${getTopPadding() + 5.5}px` }} className='flex pb-4 pl-[19px] pr-5'>
        {onBack ? <BackButton size={24} onClick={onBack} /> : <div className='h-6 w-6 shrink-0' />}
      </div>
      <div className='flex flex-col animate-fade-350 flex-1 min-h-0'>
        <MutualFundDetailPageSkeleton />
      </div>
    </div>
  )
}
